import { List } from '@phosphor-icons/react'
// The app frame: fixed sidebar (drawer ≤900px), topbar, scrolling content, FAB, phone tab bar.
export default function AppShell({ sidebar, topbar, fab, tabbar, drawerOpen = false, onCloseDrawer, children }) {
  return (
    <div className="cn-shell">
      {drawerOpen && <div className="cn-shell-backdrop" onClick={onCloseDrawer} />}
      <aside className={'cn-shell-sidebar' + (drawerOpen ? ' open' : '')}>{sidebar}</aside>
      <div className="cn-shell-main">
        <header className="cn-shell-topbar">{topbar}</header>
        <main className="cn-shell-content">{children}</main>
      </div>
      {fab}
      {tabbar}
    </div>
  )
}

export function Hamburger({ className = '', ...rest }) {
  return (
    <button className={`cn-hamburger ${className}`.trim()} {...rest}>
      <List size={18} aria-hidden="true" />
    </button>
  )
}
